module.exports = __webpack_public_path__ + "static/media/recurring_inprogress.41368802.svg";